<div class="not-found-card" artemisThemeSwitcher>
  <img src="/assets/images/logo-large.png" class="logo">
    <h2 class="not-found-card__title">Page not found</h2>
    <div class="not-found-card__msg">We're sorry, the page you requested could not be found. Please contact <a class="link link_underlined" href="mailto:clientservice@cynopsis.co" target="_blank">clientservice@cynopsis.co</a> for assistance.</div>
    <button mat-button class="btn btn_rounded" ubi-round-button (click)="backToHome()">
      Go Back
    </button>
</div>
<div class="copyright">
  <span>Copyright © 2022 Artemis</span>
  <span>All Rights Reserved</span>
</div>
